import Hero from "../../designSystem/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculators1.jpg";
import InheritanceTaxCalculator from "../../calculators/InheritanceTaxCalculator";

const InheritanceTaxPage = () => {
  return (
    <div>
      <Hero
        title="Inheritance Tax"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <InheritanceTaxCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default InheritanceTaxPage;
